import { Button, Row } from 'antd';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { type BankIntegrationProvider } from '../../../../api/types';
import CollapsibleWrapper, { Panel } from '../../../../components/wrappers/CollapsibleWrapper';
import BankIntegrationFields from './BankIntegrationFields';

export type BankIntegrationProps = {
    provider: BankIntegrationProvider;
    isUpdate?: boolean;
    disabled?: boolean;
};

const BankIntegration = ({ isUpdate = false, provider, disabled = false }: BankIntegrationProps) => {
    const { t } = useTranslation(['bankDetails']);

    const extra = useMemo(() => {
        if (isUpdate && !disabled) {
            return (
                <Button key="submit" form="bankIntegrationForm" htmlType="submit" type="primary">
                    {t('bankDetails:actions.update')}
                </Button>
            );
        }

        return null;
    }, [disabled, isUpdate, t]);

    return (
        <CollapsibleWrapper defaultActiveKey={t('bankDetails:cardTitles.bankIntegration')}>
            <Panel
                key={t('bankDetails:cardTitles.bankIntegration')}
                extra={extra}
                header={t('bankDetails:cardTitles.bankIntegration')}
            >
                <Row gutter={14}>
                    <BankIntegrationFields
                        disabled={disabled}
                        isUpdate={isUpdate}
                        nested={!isUpdate}
                        provider={provider}
                    />
                </Row>
            </Panel>
        </CollapsibleWrapper>
    );
};

export default BankIntegration;
